/**
 * Programs & Events Translations Module (English)
 * 
 * Contains: RISE, CYE, JIB, Debating, Public Speaking, Area Conferences, SDG Alignment
 * 
 * @module programs
 * @language en
 */

export const programs = {
  programsEventsPage: {
    pageSubtitle: "JCI RISE • CYE • JIB • Debating • Public Speaking • 2024-2025 Conferences"
  },
  programs: {
    // Page labels
    flagshipPrograms: "Flagship Programs",
    competitionTopics: "Competition Topics",
    skillDevelopment: "Skill Development",
    skillFocusAreas: "Skill Focus Areas",
    competitionFormat: "Competition Format",
    programDataMetrics: "Real impact data from JCI Impact Report 2025",
    
    // Core labels
    coreInitiative: "Core Initiative",
    jciRise: "JCI RISE",
    riseQuote: "Rebuilding communities, Inspiring action, Sustaining impact, Empowering youth",
    totalProjects: "Total Projects",
    beneficiaries: "Beneficiaries",
    volunteerHours: "Volunteer Hours",
    localOrganizations: "Local Organizations",
    countries: "Countries",
    projects: "projects",
    
    // RISE Pillars
    economicRecovery: "Economic Recovery",
    workforceReadiness: "Workforce Readiness",
    mentalHealth: "Mental Health",
    shareOfRiseProjects: "Share of RISE Projects",
    focusAreas: "Focus Areas",
    keyInitiatives: "Key Initiatives",
    fiiWeight: "YFI Weight",
    smeSupport: "SME support, microfinance, market access",
    skillsTraining: "Skills training, employment programs",
    awarenessSupport: "Awareness campaigns, support services",
    // RISE Economic Recovery Initiatives
    businessTraining: "Business training",
    microfinanceLinkage: "Microfinance linkage",
    marketAccess: "Market access",
    // RISE Workforce Initiatives
    stemTraining: "STEM training",
    digitalSkills: "Digital skills",
    apprenticeships: "Apprenticeships",
    // RISE Mental Health Initiatives
    supportGroups: "Support groups",
    schoolWellnessPrograms: "School wellness programs",
    hotlines: "Hotlines",
    // YFI Weight Labels
    entrepreneurship: "entrepreneurship",
    workforce: "workforce",
    mentalHealthWeight: "mental health",
    
    // Regional Distribution
    regionalProjectDistribution: "Regional Project Distribution",
    largestVolume: "Largest Volume",
    rapidGrowth: "Rapid Growth",
    consolidating: "Consolidating",
    qualityFocus: "Quality Focus",
    strategicOpportunity: "Strategic Opportunity",
    strategicOpportunityText: "America and Europe represent only 11% of projects but have strong infrastructure for RISE. Consider targeted expansion.",
    
    // SDG Alignment
    sdgAlignmentMatrix: "SDG Alignment Matrix",
    sdgsAddressed: "12 SDGs Addressed",
    riseProjectsAddress: "RISE projects address 12 of 17 UN Sustainable Development Goals",
    primaryFocusAreas: "Primary Focus Areas",
    allSdgsCoverage: "All SDGs Coverage",
    primaryFocus: "Primary Focus",
    crossCutting: "Cross-cutting",
    sizeProjectCount: "Project Count",
    
    // Resources Mobilized
    resourcesMobilized: "Resources Mobilized",
    total: "Total",
    totalResourceMobilization: "Total Resource Mobilization",
    estimatedValue: "Estimated economic value generated",
    resourceBreakdown: "Resource Breakdown",
    volunteer: "Volunteer Value",
    volunteerHoursValue: "Volunteer Value",
    corporate: "Corporate Partners",
    corporatePartnerships: "Corporate Partnerships",
    grantsFoundations: "Grants & Foundations",
    hoursAtStandardRate: "435,605 hours at standard rate",
    hoursAtStandardRates: "hours at standard rates",
    globalCorporatePar: "Global corporate partnerships",
    globalCorporatePartners: "Global corporate partners",
    foundationSupport: "Foundation and grant support",
    
    // Efficiency Metrics
    efficiencyMetrics: "Efficiency Metrics",
    costPerBeneficiary: "Cost Per Beneficiary",
    volunteerROI: "Volunteer ROI",
    partnerRetention: "Partner Retention",
    highlyEfficient: "Highly Efficient",
    forEveryDollar: "For every dollar invested",
    yearOverYear: "Year over year",
    
    // Global Youth Dialogue
    virtualEvent: "Virtual Event",
    globalYouthDialogue: "Global Youth Dialogue",
    dialogueDate: "24 September 2025",
    theme: "Theme",
    youthLeadershipUncertainty: "Youth Leadership in Times of Uncertainty",
    globalYouthLeaders: "Global Youth Leaders",
    continents: "Continents",
    registrants: "Registrants",
    liveAttendees: "Live Attendees",
    fbLiveViewers: "FB Live Viewers",
    totalReach: "Total Reach",
    comments: "Comments",
    shares: "Shares",
    reactions: "Reactions",
    
    // Event Outcomes
    eventOutcomes: "Event Outcomes",
    leadershipTrainingHours: "Leadership Training Hours",
    certificatesIssued: "Certificates Issued",
    businessPartnerships: "Business Partnerships",
    mentorshipRelationships: "Mentorship Relationships",
    riseProjectsCommissioned: "RISE Projects Commissioned",
    mediaImpressions: "Media Impressions",
    
    // Gender & Attendance
    genderDistribution: "Gender Distribution",
    male: "Male",
    female: "Female",
    nonBinary: "Non-Binary",
    attendanceType: "Attendance Type",
    events20242025: "Events 2024-2025",
    repeatAttendees: "Repeat Attendees",
    firstTime: "First Time",
    firstTimeRecruitment: "Key recruitment opportunity!",
    
    // Conferences Map
    conferencesMap: "Conferences Map",
    areaConferencesWorldCongress: "Area Conferences & World Congress",
    events: "Events",
    resetView: "Reset View",
    worldCongress: "World Congress",
    areaConference: "Area Conference",
    expected: "expected",
    openInGoogleMaps: "Open in Google Maps",
    
    // Program Detail Labels
    participants: "participants",
    teams: "teams",
    prizeMoney: "Prize Money",
    largest: "Largest",
    top: "Top",
    impact: "Impact",
    winnerProfile: "Winner Profile",
    averageAge: "Average Age",
    femaleFounders: "Female Founders",
    participationByConference: "Participation by Conference",
    curriculumAreas: "Curriculum Areas",
    outcomes: "Outcomes",
    partnerNetwork: "Partner Network",
    new: "NEW",
    learnMore: "Learn More",
    lessDetails: "Less Details"
  },
  programDetailData: {
    // CYE Program
    cyeObjective: "Developing young entrepreneurs through innovation competitions",
    cyeImpact1: "108 entrepreneurs from 20+ countries competed",
    cyeImpact2: "Over $10,000 in prize money awarded",
    cyeImpact3: "35% of participants were female founders",
    cyeImpact4: "40% in tech sector, diversifying industries",
    cyeImpact5: "Mentorship and networking connections established",
    services: "Services",
    other: "Other",
    cyeGeography: "Global distribution across all 4 JCI areas",
    cyeFiiAlignment: "Supports economic recovery and entrepreneurship dimensions of YFI",
    
    // JIB Program
    jibObjective: "Professional development and business networking",
    jibCurriculum1: "Business Innovation & Strategy",
    jibCurriculum2: "Financial Management",
    jibCurriculum3: "Global Market Access",
    jibCurriculum4: "Leadership Excellence",
    jibCurriculum5: "Mental Health in Business",
    jibOutcome1: "Reported improved business skills",
    jibOutcome2: "Expanded professional network",
    jibOutcome3: "Launched new business initiatives",
    jibOutcome4: "Increased confidence in leadership",
    jibOutcome5: "Applied mental wellness practices",
    growingRapidly: "Growing Rapidly",
    globalMentors: "Global Mentors",
    angelInvestors: "Angel Investors",
    vcNetworks: "VC Networks",
    jibFiiAlignment: "Aligns with workforce and economic YFI dimensions",
    fiiAlignment: "YFI Alignment",
    
    // Public Speaking
    publicSpeakingName: "Public Speaking Competition",
    publicSpeakingObjective: "Develops confidence and communication excellence",
    psTopic1: "Youth and Climate Action",
    psTopic2: "Leadership in Uncertainty",
    psTopic3: "Digital Transformation Impact",
    psTopic4: "Community Resilience Building",
    psSkill1: "Verbal Communication",
    psSkill2: "Critical Thinking",
    psSkill3: "Confidence Building",
    psSkill4: "Cross-cultural Awareness",
    psSkill5: "Leadership Presence",
    reportIncreasedConfidence: "report increased confidence",
    equalParticipation: "Equal Participation",
    psFiiAlignment: "Enhances workforce readiness through communication skills",
    
    // Debating
    debatingName: "Debating Championship",
    debatingObjective: "Multilingual debate competition promoting critical thinking",
    english: "English",
    french: "French",
    spanish: "Spanish",
    debateSkill1: "Analytical Reasoning",
    debateSkill2: "Structured Argumentation",
    debateSkill3: "Research Skills",
    debateSkill4: "Global Awareness",
    debateSkill5: "Academic Excellence",
    debateFormat: "World Schools Debating Format",
    debateFiiAlignment: "Develops critical thinking for workforce readiness",
    debateImpact1: "Enhanced analytical thinking",
    debateImpact2: "Improved public speaking",
    debateImpact3: "Research methodology skills",
    debateImpact4: "Cross-cultural understanding"
  },
  sdgs: {
    noPoverty: "No Poverty",
    zeroHunger: "Zero Hunger",
    goodHealth: "Good Health & Well-being",
    qualityEducation: "Quality Education",
    genderEquality: "Gender Equality",
    cleanWater: "Clean Water & Sanitation",
    affordableEnergy: "Affordable & Clean Energy",
    decentWork: "Decent Work & Economic Growth",
    industryInnovation: "Industry, Innovation & Infrastructure",
    reducedInequalities: "Reduced Inequalities",
    sustainableCities: "Sustainable Cities & Communities",
    responsibleConsumption: "Responsible Consumption & Production",
    climateAction: "Climate Action",
    lifeBelowWater: "Life Below Water",
    lifeOnLand: "Life on Land",
    peaceJustice: "Peace, Justice & Strong Institutions",
    partnerships: "Partnerships for the Goals"
  },
  programsShowcase: {
    title: "Flagship Programs & Events",
    subtitle: "Real impact data from JCI Impact Report 2025",
    coreInitiative: "Core Initiative",
    riseDesc: "Rebuilding, Inspiring, Sustaining, and Empowering communities",
    projects: "Projects",
    beneficiaries: "Beneficiaries",
    volunteerHours: "Volunteer Hours",
    risePillarsDistribution: "RISE Pillars Distribution",
    economicRecovery: "Economic Recovery",
    workforceReadiness: "Workforce Readiness",
    mentalHealth: "Mental Health",
    cye: "Creative Young Entrepreneur (CYE)",
    cyeDesc: "Regional entrepreneurship competition",
    jib: "JCI in Business (JIB)",
    jibDesc: "Business networking and development program",
    publicSpeaking: "Public Speaking Competition",
    publicSpeakingDesc: "Develops confidence and communication skills",
    debating: "Debating Championship",
    debatingDesc: "Multilingual debate competition",
    english: "English",
    french: "French",
    spanish: "Spanish",
    totalParticipants: "Total Participants",
    totalTeams: "Total Teams",
    prize: "Prize",
    teams: "teams",
    areaConferences2025: "2025 Area Conferences",
    asiaPacificConference: "Asia and the Pacific Conference",
    europeConference: "Europe Conference",
    africaMeConference: "Africa and the Middle East Conference",
    americasConference: "America Conference",
    attendees: "Attendees",
    firstTimers: "first-timers",
    featuredEvent: "Featured Event",
    globalYouthDialogue: "Global Youth Dialogue 2025",
    registrants: "Registrants",
    liveAttendees: "Live Attendees",
    fbLiveViewers: "FB Live Viewers",
    chatMessages: "Chat Messages",
    jciSenators: "JCI Senators",
    senatorsNew: "84 new in 2025",
    toypRecognized: "TOYP Recognized",
    toypCategories: "10 categories",
    peopleImpacted: "People Impacted",
    throughAllPrograms: "Through all programs",
    sourceNote: "JCI Impact Report 2025 - Official program and event data"
  },
  sdgAlignment: {
    title: "SDG Alignment",
    subtitle: "JCI programs mapped to UN Sustainable Development Goals",
    sdgCount: "SDGs Covered",
    sdgCountDesc: "JCI programs contribute to 12 of 17 UN SDGs",
    primaryGoals: "Primary Goals",
    primaryGoalsDesc: "Most impacted by JCI initiatives",
    goodHealth: "Good Health and Well-being",
    qualityEducation: "Quality Education",
    decentWork: "Decent Work and Economic Growth",
    reducedInequalities: "Reduced Inequalities",
    partnerships: "Partnerships for the Goals",
    impactMapping: "Impact Mapping",
    riseProjects: "RISE Projects",
    riseProjectsDesc: "Aligned with mental health, workforce, and economic recovery",
    cyeProgram: "CYE Program",
    cyeDesc: "Supports entrepreneurship and innovation",
    jibProgram: "JIB Program",
    jibDesc: "Fosters business skills and professional networks",
    toyp: "TOYP",
    toypDesc: "Recognizes youth leadership and impact",
    sourceNote: "Source: JCI Impact Report 2025 - SDG alignment methodology"
  },
  impactMetricsTitle: "Impact Metrics",
  impactMetricsSubtitle: "Measuring JCI's global reach and community impact",
  riseTitle: "RISE Initiative",
  riseSubtitle: "Rebuilding, Inspiring, Sustaining, and Empowering communities",
  cyeTitle: "Creative Young Entrepreneurs (CYE)",
  cyeSubtitle: "Regional entrepreneurship competition",
  jibTitle: "JCI in Business (JIB)",
  jibSubtitle: "Business networking and professional development",
  debatingTitle: "Debating Championship",
  debatingSubtitle: "Multilingual debate competition fostering critical thinking",
  publicSpeakingTitle: "Public Speaking Competition",
  publicSpeakingSubtitle: "Developing confidence and communication skills",
  conferencesTitle: "Area Conferences",
  conferencesSubtitle: "Annual regional gatherings for networking and training",
  rise: {
    title: "JCI RISE Initiative",
    subtitle: "Rebuilding, Inspiring, Sustaining, and Empowering communities",
    totalProjects: "Total RISE Projects",
    beneficiariesReached: "Beneficiaries Reached",
    volunteerHours: "Volunteer Hours",
    budgetMobilized: "Budget Mobilized",
    pillarDistribution: "Pillar Distribution",
    mentalHealth: "Mental Health",
    workforceReadiness: "Workforce Readiness",
    economicRecovery: "Economic Recovery",
    regionalBreakdown: "Regional Breakdown",
    projectsByRegion: "Projects by Region",
    topProjects: "Top RISE Projects by Impact",
    viewFullReport: "View Full RISE Report"
  },
  cye: {
    title: "Creative Young Entrepreneurs (CYE)",
    subtitle: "Regional entrepreneurship competition fostering innovation",
    participants: "Total Participants",
    teams: "Total Teams",
    prizePool: "Total Prize Pool",
    winnersTitle: "2024 Winners",
    categories: "Competition Categories",
    socialEnterprise: "Social Enterprise",
    techInnovation: "Technology & Innovation",
    greenBusiness: "Green Business",
    traditionalBusiness: "Traditional Business",
    impactMetrics: "Impact Metrics",
    businessesLaunched: "Businesses Launched",
    jobsCreated: "Jobs Created",
    fundingSecured: "Funding Secured"
  },
  jib: {
    title: "JCI in Business (JIB)",
    subtitle: "Professional development and business networking program",
    activeMembers: "Active JIB Members",
    networkingEvents: "Networking Events",
    businessPartnerships: "Business Partnerships",
    benefits: "JIB Benefits",
    professionalNetwork: "Professional network access",
    businessSkills: "Business skills development",
    mentorship: "Mentorship opportunities",
    careerAdvancement: "Career advancement support",
    focusAreas: "Focus Areas",
    leadership: "Leadership Development",
    networking: "Business Networking",
    skills: "Professional Skills",
    entrepreneurship: "Entrepreneurship Support"
  },
  debating: {
    title: "JCI Debating Championship",
    subtitle: "Multilingual debate competition promoting critical thinking",
    totalTeams: "Total Teams",
    languages: "Languages",
    countries: "Participating Countries",
    format: "Competition Format",
    preliminaryRounds: "Preliminary Rounds",
    semifinals: "Semifinals",
    grandFinal: "Grand Final",
    skillsDeveloped: "Skills Developed",
    criticalThinking: "Critical Thinking",
    publicSpeaking: "Public Speaking",
    research: "Research & Analysis",
    teamwork: "Teamwork & Collaboration",
    recentChampions: "Recent Champions",
    viewHighlights: "View Debate Highlights"
  },
  publicSpeaking: {
    title: "Public Speaking Competition",
    subtitle: "Building confidence and communication excellence",
    participants: "Total Participants",
    countries: "Participating Countries",
    speechTopics: "Speech Topics",
    improvisation: "Impromptu Speaking",
    prepared: "Prepared Speech",
    persuasive: "Persuasive Speech",
    competencies: "Competencies Evaluated",
    delivery: "Delivery & Presence",
    content: "Content & Structure",
    impact: "Impact & Persuasion",
    languageProficiency: "Language Proficiency",
    recentWinners: "Recent Winners",
    watchSpeeches: "Watch Winning Speeches"
  },
  conferences: {
    title: "JCI Area Conferences",
    subtitle: "Annual regional gatherings for networking, training, and leadership",
    totalAttendees: "Total Attendees (2025)",
    conferences: "Conferences",
    firstTimers: "First-time Attendees",
    countries: "Countries Represented",
    conferenceHighlights: "Conference Highlights",
    keynotes: "Keynote Speakers",
    workshops: "Training Workshops",
    networking: "Networking Sessions",
    awards: "Awards & Recognition",
    upcomingConferences: "Upcoming Conferences 2025",
    registerNow: "Register Now",
    viewSchedule: "View Schedule"
  },
  toyp: {
    title: "Ten Outstanding Young Persons (TOYP)",
    subtitle: "Recognizing exceptional young leaders worldwide",
    recognizedLeaders: "Leaders Recognized (2025)",
    categories: "Award Categories",
    nominationsOpen: "Nominations Period",
    categoryList: {
      businessEconomic: "Business & Economic Accomplishment",
      humanitarian: "Humanitarian & Voluntary Service",
      science: "Academic Leadership & Accomplishment",
      political: "Political, Legal & Governmental Affairs",
      cultural: "Cultural Achievement",
      medical: "Medical Innovation",
      environmental: "Environmental Leadership",
      world: "World Peace & Human Rights",
      children: "Child Welfare & Education",
      personal: "Personal Improvement & Accomplishment"
    },
    selectionProcess: "Selection Process",
    nomination: "Nomination",
    evaluation: "Evaluation",
    recognition: "Recognition",
    pastHonorées: "Past TOYP Honorées",
    submitNomination: "Submit Nomination"
  },
  programMetrics: {
    title: "Program Participation Metrics",
    subtitle: "Member engagement across JCI programs",
    totalParticipants: "Total Program Participants",
    programReach: "Program Reach by Region",
    growthTrend: "Year-over-Year Growth",
    satisfactionScore: "Participant Satisfaction",
    highRating: "High Rating",
    repeatParticipation: "Repeat Participation",
    likelyToRecommend: "Likely to recommend",
    topPerformingPrograms: "Top Performing Programs",
    program: "Program",
    participants: "Participants",
    satisfaction: "Satisfaction",
    growth: "Growth"
  },
  programImpact: {
    title: "Program Impact Assessment",
    subtitle: "Measuring outcomes and long-term impact",
    skillsDevelopment: "Skills Development",
    reportImprovedSkills: "Report improved leadership skills",
    networkGrowth: "Network Growth",
    expandedNetwork: "Expanded professional network",
    careerAdvancement: "Career Advancement",
    careerProgress: "Attribute career progress to JCI",
    communityImpact: "Community Impact",
    ledCommunityProjects: "Led or participated in community projects",
    impactStories: "Impact Stories",
    readStories: "Read Member Stories",
    shareYourStory: "Share Your Story"
  },
  humanDuties: {
    title: "International Human Duties Initiative",
    headline: "67,101 Global Voices for Ethical Leadership",
    heroDescription: "The International Human Duties Initiative represents a pivotal shift in global leadership discourse. While human rights are widely recognized, the complementary concept of human duties—the responsibilities that accompany rights—remains underexplored. JCI is leading this conversation through the Universal Declaration of Human Duties for Leaders, with over 67,000 young leaders worldwide already pledging their commitment to ethical, responsible leadership.",
    totalPetitions: "Total Petitions Signed",
    globalSignatories: "global signatories",
    geographicCoverage: "Geographic Coverage",
    countriesAcross: "countries across 4 regions",
    nationalAmbassadors: "National Ambassadors",
    leadingCoordination: "leading IHDD coordination",
    campaignDuration: "Campaign Duration",
    campaignPeriod: "January – October 2025 (via change.org)",
    regionalBreakdown: "Regional Breakdown",
    region: "Region",
    petitionsSigned: "Petitions Signed",
    percentGlobal: "% of Global",
    ambassadorEngagement: "Ambassador Engagement",
    asiaPacific: "Asia and the Pacific",
    africaMiddleEast: "Africa and the Middle East",
    americas: "America",
    europe: "Europe",
    highMomentum: "High momentum",
    growingActivities: "Growing (19 activities)",
    establishedBase: "Established base",
    emerging: "Emerging",
    keyMilestones: "Key Institutional Milestones",
    nelsonMandelaEndorsement: "Nelson Mandela Foundation Endorsement",
    mandelaDesc: "Official recognition of Human Duties Initiative (2025)",
    legislativeSuccess: "Legislative Success",
    legislativeDesc: "State of Zulia (Venezuela) enacted Law on Human Duties, declared July 10 as International Human Duties Day (2025)",
    officialPortal: "Official Portal",
    portalDesc: "internationalhumanduties.com launched to centralize resources",
    ihddImpact: "International Human Duties Day (IHDD) Impact",
    reportedActivities: "2025 Reported Activities",
    activitiesAcrossRegions: "officially documented initiatives across regions",
    activities: "Activities",
    percentTotal: "% of Total",
    newAward: "Best Human Duties Project Award",
    newAwardDesc: "Introduced to recognize outstanding local initiatives (2025)",
    sevenDutiesFramework: "The 7 Duties for Leaders Framework",
    duty1: "Duty to Uphold Human Dignity",
    duty2: "Duty to Serve the Common Good",
    duty3: "Duty to Protect the Environment",
    duty4: "Duty to Promote Equity and Justice",
    duty5: "Duty to Foster Peace and Understanding",
    duty6: "Duty to Support Education and Development",
    duty7: "Duty to Act with Integrity and Accountability",
    ctaTitle: "Be Part of the Movement",
    signPetition: "Sign the Petition",
    becomeAmbassador: "Become a National Ambassador",
    viewStories: "View IHDD Stories",
    sourceNote: "Source: JCI Impact Report 2025 – Human Duties Initiative Data"
  },
  strategicPartnerships: {
    title: "Strategic Global Partnerships",
    headline: "Building Bridges: JCI's Strategic Global Partnerships",
    heroDescription: "JCI's impact is amplified through strategic partnerships with global organizations that share our commitment to developing young leaders and advancing sustainable development. These collaborations expand member opportunities, open international networks, and create channels for peer-to-peer engagement.",
    activePartnership: "Active partnership",
    growingPartnership: "Growing partnership",
    emergingPartnership: "Emerging partnership",
    infrastructurePartner: "Infrastructure partner",
    partnershipTiers: "Partnership Tiers",
    tier1Active: "Tier 1: Active Partnerships",
    tier1Desc: "Continue collaboration, expand mentorship",
    tier2Growing: "Tier 2: Growing Partnerships",
    tier2Desc: "6-month roadmap for deeper integration",
    tier3Emerging: "Tier 3: Emerging Partnerships",
    tier3Desc: "Strategic for organizational growth",
    tier4Infrastructure: "Tier 4: Infrastructure Partners",
    tier4Desc: "Operational efficiency and digital enablement",
    roiIndicators: "Partnership ROI Indicators",
    partner: "Partner",
    memberBenefit: "Member Benefit",
    orgBenefit: "Organizational Benefit",
    effortLevel: "Effort Level",
    roiTimeline: "ROI Timeline",
    businessNetworking: "Business networking",
    policyInfluence: "Policy influence",
    credibility: "Credibility",
    trainingCertification: "Training certification",
    educationAuthority: "Education authority",
    financingAccess: "Financing access",
    economicVoice: "Economic voice",
    globalVisibility: "Global visibility",
    thoughtLeadership: "Thought leadership",
    internshipAccess: "Internship access",
    studentPipeline: "Student pipeline",
    referralNetwork: "Referral network",
    entrepreneurshipSupport: "Entrepreneurship support",
    genderEquity: "Gender equity",
    diversityValidation: "Diversity validation",
    digitalTools: "Digital tools",
    operationalEfficiency: "Operational efficiency",
    employmentAdvocacy: "Employment advocacy",
    low: "Low",
    medium: "Medium",
    veryLow: "Very Low",
    immediate: "Immediate",
    threeMonths: "3 months",
    sixMonths: "6 months",
    oneYear: "1 year",
    iccName: "International Chamber of Commerce (ICC)",
    iccValue: "Access to global business community, B2B networking infrastructure",
    iccMetric: "345 entrepreneurs engaged in JCI in Business network sessions",
    unName: "United Nations (UN)",
    unValue: "Global policy influence, SDG alignment legitimacy, media amplification",
    unMetric: "ECOSOC Consultative Status since 1954, 1,000+ SDG-aligned projects",
    unescoName: "UNESCO",
    unescoValue: "Education credibility, curriculum development, trainer certification",
    unescoMetric: "97 certified trainers, 1,969 participants in 81 global sessions",
    worldBankName: "World Bank / IFC",
    worldBankValue: "Economic development research, financing for young entrepreneurs",
    worldBankMetric: "$1.7T financing gap analysis, 108 CYE entrepreneurs",
    wefName: "World Economic Forum (WEF)",
    wefValue: "Thought leadership platform, elite business/government network",
    wefMetric: "Global Shapers alignment opportunity, Future of Jobs research",
    aiesecName: "AIESEC",
    aiesecValue: "University networks, internship exchange mechanisms",
    aiesecMetric: "75,000+ student leaders, cross-country exchange potential",
    bniName: "BNI (Business Network International)",
    bniValue: "Business referral networks, SMB growth support",
    bniMetric: "300K+ business members globally",
    wbafName: "Women Business Alliance Forum (WBAF)",
    wbafValue: "Female entrepreneur support, gender equity advocacy",
    wbafMetric: "43% female JCI membership, 37% female Senators",
    zohoName: "Zoho",
    zohoValue: "Digital transformation, CRM and project management tools",
    zohoMetric: "4,641 local organizations could benefit from digital toolkit",
    gyefName: "Global Youth Economic Forum (GYEF)",
    gyefValue: "Youth employment policy network, advocacy platform",
    gyefMetric: "Youth economic empowerment research collaboration",
    ctaTitle: "Join the Partnership Network",
    viewAllPartnerships: "View All Partnerships",
    partnerWithJCI: "Partner with JCI",
    accessResources: "Access Partner Resources",
    sourceNote: "Source: JCI Impact Report 2025 – Strategic Partnerships"
  }
} as const;
